import { Action } from '@ngrx/store';

export const SIGN_ESIGN = 'SIGN_ESIGN';

export class Sign_ESign implements Action {
  readonly type = SIGN_ESIGN;

  constructor(public payload) { }

}

export type SelfEnrollActions = Sign_ESign;